// Phase 10A — Operations Command Center dashboard API client.
// Mirrors the shape of the other per-domain clients; every call is a
// thin wrapper over `apiFetch` that forwards query params straight
// through. Dealer scoping is enforced server-side against
// `get_current_user`, so callers never pass `dealer_id` here.
import { apiFetch } from './client';

export const dashboardApi = {
  summary: (params) => apiFetch('/api/dashboard/summary', { params }),
  callVolume: (params) => apiFetch('/api/dashboard/call-volume', { params }),
  intentDistribution: (params) =>
    apiFetch('/api/dashboard/intent-distribution', { params }),
  objections: (params) => apiFetch('/api/dashboard/objections', { params }),
  funnel: (params) => apiFetch('/api/dashboard/funnel', { params }),
  hotLeads: (params) => apiFetch('/api/dashboard/hot-leads', { params }),
  urgentTasks: (params) => apiFetch('/api/dashboard/urgent-tasks', { params }),
  upcomingAppointments: (params) =>
    apiFetch('/api/dashboard/upcoming-appointments', { params }),
  reminderActivity: (params) =>
    apiFetch('/api/dashboard/reminder-activity', { params }),
};
